import React from "react";
import Select from "react-select";
import { Field } from "formik"; // Assuming you're using Formik
import CreatableSelect from "react-select/creatable";
import StarIcon from "../../assets/icons/req-star";

const ItemsSelectField = ({
  name,
  label = "Uom",
  isLabelReq,
  placeholder,
  labelClass = "min-h-[1.2rem] text-[var(--items-search-input-label-color)] text-[length:var(--items-search-label-fs)] font-[var(--items-search-label-font-weight)]",
  options, // Accept options as prop
  isCreatable = false,
  disabled,
  isRequired = false,
  key = "",
  handleSelect = () => { },
}) => {
  const SelectComponent = isCreatable ? CreatableSelect : Select;

  return (
    <Field name={name}>
      {({ field, form }) => (
        <div className="flex flex-col w-full">
          {isLabelReq && (
            <div className="flex ">
              <label className={`${labelClass}`}>{label}</label>
              {isRequired && (
                <span className="ml-2">
                  <StarIcon />
                </span>
              )}
            </div>
          )}

          <SelectComponent
            key={key}
            menuPortalTarget={document.body}
            {...field}
            isDisabled={disabled}
            menuPlacement="auto"
            value={options?.find((option) => option.value === field.value)} // <-- important fix
            options={options} // Options come from props
            styles={customStyles} // Apply custom styles here
            onChange={(selectedOption) => {
              form.setFieldValue(name, selectedOption.value);
              handleSelect(selectedOption);
            }}
            isSearchable={true} // Enable search
            placeholder={placeholder} // Default placeholder
          />
        </div>
      )}
    </Field>
  );
};

const customStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    backgroundColor: "var(--items-search-input-bg)", // Using provided variable
    color: "var(--items-search-input-color)", // Using provided variable
    fontSize: "var(--items-search-input-font-size)", // Using provided variable
    fontWeight: "var(--items-search-input-font-weight)", // Using provided variable
    borderColor: state.isFocused
      ? "var(--items-search-input-focus)" // Using provided variable
      : "var(--items-search-input-border)", // Using provided variable
    boxShadow: "none",
    borderRadius: "6px",
    padding: "0",
    margin: "0",
    minHeight: "40px",
    "&:hover": {
      borderColor: "var(--items-search-input-focus)", // Using provided variable
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "3px 6px",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isDisabled
      ? "#aaaaaa"
      : state.data.color
        ? state.data.color
        : "var(--items-search-input-color)",
    backgroundColor: state.isDisabled
      ? "transparent"
      : state.isSelected
        ? "#e5ecffb2"
        : state.isFocused
          ? "#0000002E"
          : "transparent",
    cursor: state.isDisabled ? "not-allowed" : "default",
    borderBottom: "1px solid #F5F5F5",
    fontFamily: "Inter, sans-serif",
    fontSize: "var(--items-search-place-font-size)",
    fontWeight: "var(--items-search-place-font-weight)",
    "&:hover": {
      backgroundColor: state.isDisabled ? "transparent" : "#0000002E",
    },
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: "var(--items-search-place-color)", // Using provided variable
    fontFamily: "Inter, sans-serif",
    fontSize: "var(--items-search-place-font-size)", // Using provided variable
    fontWeight: "var(--items-search-place-font-weight)", // Using provided variable
    opacity: "0.9",
  }),
  singleValue: (base) => ({
    ...base,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "var(--items-search-input-color)", // Using provided variable
    fontSize: "var(--items-search-input-font-size)", // Using provided variable
    fontWeight: "var(--items-search-input-font-weight)", // Using provided variable
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#E5ECFF",
    gap: "5px",
    padding: "0px 6px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "0 5px", // Reduced padding for the icon size
    fontSize: "12px", // Reduce the font size (works with font-based icons)
    transform: "scale(0.8)", // Reduce the size of the icon by 20%
  }),
};

export default ItemsSelectField;
